import { render } from "./DatabaseSwitcher.vue?vue&type=template&id=7390c1ff&scoped=true"
import script from "./DatabaseSwitcher.vue?vue&type=script&lang=js"
export * from "./DatabaseSwitcher.vue?vue&type=script&lang=js"

import "./DatabaseSwitcher.vue?vue&type=style&index=0&id=7390c1ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7390c1ff"]])

export default __exports__